<template>
    <div class="panel-content">
        <h2>Research</h2>
        <img class="header" src="/static/img/overlay-assets/header7-3.jpg" />
        <p>Het bij het Tracer Center Amsterdam uitgevoerde onderzoek is gericht op de ontwikkeling van radiofarmaca en optische beeldvormingssondes. Zeer deskundige internationale medewerkers leggen zich toe op:</p>
        <ul>
            <li>fundamenteel onderzoek gericht op de productie van radionucliden en radiochemische methoden;</li>
            <li>methoden voor (geautomatiseerde) synthese en zuivering van radiofarmaca en optische beeldvormingssondes;</li>
            <li>selectie en validatie van biologische doelwitten (zoals enzymen en receptoren) en in-vitro-beoordeling van nieuwe radiofarmaca en optische beeldvormingssondes die op deze doelwitten inwerken;</li>
            <li>selectie van leads en de optimalisering van leads voor nieuwe radiofarmaca;</li>
            <li>preklinische in-vivo-beoordeling van nieuwe radiofarmaca en optische beeldvormingssondes en onderzoek naar GMP-conforme synthesemethoden voor radiofarmaca en optische beeldvormingssondes.</li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
